;(function () {

"use strict";

var GiftWrapView = require('../views/gift-wrap');

var MiniCartQuantityView = require('../views/mini-cart-quantity');

var SliderView = require('../views/slider');

var CartQuantityView = MiniCartQuantityView.extend({
  update: function () {
    this.$input.val(this.qty);
  }
});

var CharacterLimitView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};
    this.maxlen = opts.maxlen || 150;
  },
  update: function (e) {
    var $this = $(e.currentTarget);
    var val = $this.val();
    var $number = $this.parent().find('.max-chars strong');
    var $copy = $this.parent().find('.max-chars span');

    var remaining = this.maxlen - val.length;
    if (remaining < 0) {
      remaining = 0;
    }

    if (remaining === 1) {
      $copy.html('character remaining');
    } else {
      $copy.html('characters remaining');
    }

    $number.html(remaining);

    if (remaining <= 0) {
      $this.val(val.slice(0, this.maxlen));
      return false;
    }
  },
  events:{
    'keyup textarea': 'update'
  }
});

var PageView = Backbone.View.extend({
  initialize: function () {
    // console.log('init cart view');

    this.$el.find('.tbody .js-quantity').each(function () {
      new CartQuantityView({el: this });
    });

    new GiftWrapView({el: this.$el.find('.tbody .gift-wrap').first() });
    new CharacterLimitView({el: this.$el.find('.tbody .gift-wrap') });

    new SliderView({ el: this.$el.find('.slider.desktop'), group: 3 });    
    new SliderView({ el: this.$el.find('.slider.mobile') });
  }
});

module.exports = PageView;

}());